module.exports = __webpack_public_path__ + "img/icon-Social1.6ac27464.png";